import { Controller } from "@hotwired/stimulus";

// Auto-submit filter forms when select fields change
export default class extends Controller {
  submit() {
    this.element.requestSubmit();
  }
}
